import { useState } from 'react'

import { ButtonTypes } from '@cox/core-ui8/dist/Button'
import { FormOptionsTypes } from '@cox/core-ui8/dist/Form'
import FormDropdown from '@cox/core-ui8/dist/FormDropdown'

import { ChannelLineupSubHeaderProps } from './types'
import { getDropdownOptions } from '../../../utils/channel-lineup-util'
import ReactButton from '../../ReactButton'
import './ChannelLineupSubHeader.scss'
import ChannelSearchModal from '../ChannelSearchModal'

const ChannelLineupSubHeader = (props: ChannelLineupSubHeaderProps) => {
  const {
    sortChannelsOptionsTitle = '',
    searchBtnText = '',
    lineupData = {},
    updateLineupParams,
    resetSearchText,
    filteredByText,
    setSearchParamsQueryString
  } = props

  const [showModal, setShowModal] = useState(false)

  const [channel, setChannel] = useState('')
  const [genre, setGenre] = useState('0')
  const [tvPack, setTvPack] = useState('0')
  const defaultRadioOption = lineupData?.refineBody?.filter((option: any) => option.selected == true)[0]?.value || ''
  const [tvPackage, setTvPackage] = useState(defaultRadioOption)
  const [optionalFilters, setOptionalFilters] = useState<any[]>([])

  const resetSearch = () => {
    setSearchParamsQueryString('')
    updateLineupParams('reset')

    //Reset Modal Form
    setChannel('')
    setGenre('0')
    setTvPack('0')
    setTvPackage(defaultRadioOption)
    setOptionalFilters([])
  }

  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleSortData = (e: any) => {
    updateLineupParams('sort', e)
  }

  return (
    <div className='channel-lineup__subheader'>
      <div className='subheader-top-section'>
        <div className='left-section'>
          <ReactButton
            id='channel-search'
            text={searchBtnText}
            buttonTypes={ButtonTypes.PRIMARY}
            customClickEvent={handleShowModal}
          />
          <ReactButton
            id='reset-search'
            text={resetSearchText}
            buttonTypes={ButtonTypes.SECONDARY}
            customClickEvent={() => {
              resetSearch()
            }}
          />
          <ChannelSearchModal
            {...props}
            showModal={showModal}
            setShowModal={setShowModal}
            lineupData={lineupData}
            genre={genre}
            setGenre={setGenre}
            tvPack={tvPack}
            setTvPack={setTvPack}
            tvPackage={tvPackage}
            setTvPackage={setTvPackage}
            channel={channel}
            setChannel={setChannel}
            optionalFilters={optionalFilters}
            setOptionalFilters={setOptionalFilters}
            updateLineupParams={updateLineupParams}
          />
        </div>
        {!lineupData?.loading && lineupData?.sortSelect && (
          <div className='right-section'>
            <FormDropdown
              id={'sort-channels-dropdown-modal'}
              title={sortChannelsOptionsTitle}
              name='sort-channels-dropdown-modal'
              type={FormOptionsTypes.dropdown}
              searchEnabled={false}
              items={getDropdownOptions(lineupData?.sortSelect)}
              onChange={(e) => handleSortData(e)}
            />
          </div>
        )}
      </div>
      {lineupData?.filter?.length > 0 && (
        <div className='subheader-bottom-section'>
          <p className='filtered-by-text'>{filteredByText}</p>
          <div className='filters-list'>
            {lineupData?.filter?.map((item: any, index: number) => (
              <p key={index} className='filters-list-item'>
                {item.term}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ChannelLineupSubHeader
